<template>
    <div class="seismic-safety-news">
        <div class="container">
            <div class="section-title">
                <h3>{{ pageSetup.safety_news_title }}</h3>
                <div class="swiper-controls seismic-news-controls" v-if="!isMobileChecker">
                    <div class="seismic-btn-prev slider-btn">
                        <svgIcon name="left-arrow" class="icon icon-arrow-left"/>
                    </div>
                    <div class="seismic-btn-next slider-btn">
                        <svgIcon name="right-arrow" class="icon icon-arrow-right"/>
                    </div>
                </div>
            </div>
            <div class="news-items-safety" v-if="newsItems != null && !isMobileChecker">
                <swiper :options="swiperOption" ref="aboutHistoryCarousel">
                    <swiper-slide v-for="item in newsItems">
                        <div class="news-item">
                            <router-link :to="{ name: 'news-card' , params:{'id' : item.slug}}" @click.native="startLoader">
                                <div class="news-item-img">
                                    <img :src="item.acf.news_img" alt="">
                                </div>
                                <div class="news-title">
                                    <h2 v-html="item.acf.title"></h2>
                                </div>
                                <div class="news-desc" v-if="item.acf.first_elem_default.desc_red.length">
                                    <p v-for="desc in item.acf.first_elem_default.desc_red" v-html="desc.desc"></p>
                                </div>
                                <div class="news-date">
                                    <span>{{correctDate(item.date)}}</span>
                                    <div class="btn-go-to-page"><svgIcon name="arrow-go-right"/></div>
                                </div>
                            </router-link>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="news-items-safety" v-if="newsItems != null && isMobileChecker">
                <swiper :options="swiperOptionMobile">
                    <swiper-slide v-for="item in newsItems">
                        <div class="news-item">
                            <router-link :to="{ name: 'news-card' , params:{'id' : item.slug}}" @click.native="startLoader">
                                <div class="news-item-img">
                                    <img :src="item.acf.news_img" alt="">
                                </div>
                                <div class="news-title">
                                    <h2 v-html="item.acf.title"></h2>
                                </div>
                                <div class="news-desc" v-if="item.acf.first_elem_default.desc_red.length">
                                    <p v-for="desc in item.acf.first_elem_default.desc_red" v-html="desc.desc"></p>
                                </div>
                                <div class="news-date">
                                    <span>{{correctDate(item.date)}}</span>
                                    <div class="btn-go-to-page"><svgIcon name="arrow-go-right"/></div>
                                </div>
                            </router-link>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="swiper-controls seismic-news-controls" v-if="isMobileChecker">
                <div class="seismic-btn-prev seismic-btn-prev-mobile slider-btn">
                    <svgIcon name="left-arrow" class="icon icon-arrow-left"/>
                </div>
                <div class="seismic-btn-next seismic-btn-next-mobile slider-btn">
                    <svgIcon name="right-arrow" class="icon icon-arrow-right"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'seismic-safety-news',
        components: {
            svgIcon,
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    loop: false,
                    observer: true,
                    spaceBetween: 16,
                    // effect: 'slide',
                    slidesPerView: 4,
                    simulateTouch: true,
                    navigation: {
                        nextEl: '.seismic-btn-next',
                        prevEl: '.seismic-btn-prev',
                    },
                    pagination: {
                        el: '.seismic-sales-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        // when window width is >= 900px
                        900: {
                            slidesPerView: 'auto',
                            spaceBetween: 20
                        },
                    }
                },
                swiperOptionMobile: {
                    speed: 1000,
                    observer: true,
                    observeSlideChildren: true,
                    observeParents: true,
                    resizeObserver: true,
                    effect: 'slide',
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // autoplay: {
                    //     delay: 3000,
                    //     disableOnInteraction: true,
                    // },
                    navigation: {
                        nextEl: '.seismic-btn-next-mobile',
                        prevEl: '.seismic-btn-prev-mobile',
                    },
                },
            }
        },
        computed: mapGetters({
            pageSetup: 'loadSeismicSafetyPage',
            newsItems: 'loadSeismicSafetyNewsItems',
            setup: 'loadPageSetUp',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getSafetyNewsItems() {
                if (this.pageSetup != null) {
                    const data = this.pageSetup.safety_news;
                    // console.log(data)
                    var id_str = [];
                    for (var i=0; i<data.length; i++) {
                        id_str.push(data[i].news.ID);
                    }
                    // var correct_str = id_str.match(/.{0,4}/g);
                    // var id_s = correct_str.join(",");
                    // console.log(id_str.join(','), 'ID')
                    this.$store.dispatch('getSeismicSafetyNewsByIDs', id_str.join(','));
                }
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8, 10));
                var month = date.slice(5, 7);
                var year = date.slice(0, 4);
                var monthFont;
                var total;
                var monthNames = {
                    '01': { 'kz/': 'Қаңтар', 'en/': 'January', 'default': 'Января' },
                    '02': { 'kz/': 'Ақпан', 'en/': 'February', 'default': 'Февраля' },
                    '03': { 'kz/': 'Наурыз', 'en/': 'March', 'default': 'Марта' },
                    '04': { 'kz/': 'Сәуiр', 'en/': 'April', 'default': 'Апреля' },
                    '05': { 'kz/': 'Мамыр', 'en/': 'May', 'default': 'Мая' },
                    '06': { 'kz/': 'Маусым', 'en/': 'June', 'default': 'Июня' },
                    '07': { 'kz/': 'Шiлде', 'en/': 'July', 'default': 'Июля' },
                    '08': { 'kz/': 'Тамыз', 'en/': 'August', 'default': 'Августа' },
                    '09': { 'kz/': 'Қыркүйек', 'en/': 'September', 'default': 'Сентября' },
                    '10': { 'kz/': 'Қазан', 'en/': 'October', 'default': 'Октября' },
                    '11': { 'kz/': 'Қараша', 'en/': 'November', 'default': 'Ноября' },
                    '12': { 'kz/': 'Желтоқсан', 'en/': 'December', 'default': 'Декабря' }
                };
                monthFont = monthNames[month] ? monthNames[month][this.lang] || monthNames[month]['default'] : '';
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
        },
        created () {
        },
        mounted() {
            this.getSafetyNewsItems();
            this.$store.watch(
                (state) => state.seismicSafetyPage,
                (newValue) => {
                    if (newValue) 
                    this.getSafetyNewsItems();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/seismic-safety/seismic-safety-news.scss';
    @import '@/styles/components/seismic-safety/respond/seismic-safety-news-respond.scss';
    // @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>